// 전체 내보내기 — 대표만 · 고객·견적·계약·현장·일지·변경공사(CSV)와 원본(data.json)·현장 사진을 ZIP 하나로.

import { Download } from "lucide-react";

import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import { signedDownload } from "@/lib/signed-url";

export const FULL_EXPORT_PATH = "/app/settings/export";

const SettingsExport = () => (
  <SectionCard
    data-testid="settings-export"
    description="고객·견적·계약·현장·현장일지·변경공사를 Excel 로 열리는 CSV 로, 견적·계약 스냅샷까지 전부를 data.json 으로, 현장 사진은 원본 그대로 ZIP 하나에 담습니다. 사진이 많으면 시간이 걸립니다."
    title="전체 내보내기">
    <div className="flex flex-col items-start gap-2">
      <Button asChild data-testid="settings-export-download" size="sm" variant="outline">
        <a download href={FULL_EXPORT_PATH} onClick={signedDownload(FULL_EXPORT_PATH)}>
          <Download className="size-4" />
          전체 내보내기
        </a>
      </Button>
      {/* 실패(503·404)는 빈 파일로 끝나 화면이 알 수 없다 — 미리 적어 둔다. */}
      <p className="text-xs text-muted-foreground" data-testid="settings-export-hint">
        내려받기가 실패하면 1분 뒤 다시 눌러 주세요 · 사진이 많으면 시간이 걸립니다.
      </p>
    </div>
  </SectionCard>
);

export default SettingsExport;
